import {
  INIT, SUCCESS, LOADING, ERROR,
} from '../../../utils/constants';
import {
  GET_DB_AZURE, GET_DB_AZURE_SUCCESS, GET_DB_AZURE_ERROR
} from './constant';


const initialState = {
  phase: INIT,
  azureDBList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */
 

export function AzureDBStore(state = initialState, action) {
  switch (action.type) {
    case GET_DB_AZURE:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_DB_AZURE_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureDBList: action.data,
        error: null,
      };
    case GET_DB_AZURE_ERROR:
      return { ...state, phase: ERROR, error: action.error };
    default:
      return state;
  }
}
